var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { space, color, themeGet, display, fontSize, lineHeight, justifyContent, flexDirection, textAlign, } from 'styled-system';
import { getTrackerProps } from '../../common/tracking/getTrackerProps';
import { LocaleConsumer } from '../../common/providers/LocaleProvider';
import { Grid, GridItem } from '../../common/components/Grid';
var UspBarContainer = styled(GridItem)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), display, justifyContent, flexDirection);
UspBarContainer.defaultProps = {
    display: ['none', null, 'flex'],
    justifyContent: 'space-between',
};
var UspBarText = styled.p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n\n  text-transform: ", ";\n  letter-spacing: 1px;\n"], ["\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n\n  text-transform: ", ";\n  letter-spacing: 1px;\n"])), color, space, fontSize, lineHeight, textAlign, function (props) { return props.textTransform; });
UspBarText.defaultProps = {
    color: 'gray.9',
    my: [1, null, 2],
    mx: 0,
    fontSize: '11px',
    lineHeight: 1,
    textTransform: 'uppercase',
};
var UspBarContent = styled(UspBarText)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  letter-spacing: normal;\n\n  & {\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      font-size: 13px;\n      font-weight: bold;\n      margin-top: 8px;\n      margin-bottom: 8px;\n    }\n  }\n\n  & p {\n    margin-top: 8px;\n    margin-bottom: 8px;\n  }\n"], ["\n  letter-spacing: normal;\n\n  & {\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      font-size: 13px;\n      font-weight: bold;\n      margin-top: 8px;\n      margin-bottom: 8px;\n    }\n  }\n\n  & p {\n    margin-top: 8px;\n    margin-bottom: 8px;\n  }\n"])));
UspBarContent.defaultProps = __assign(__assign({}, UspBarText.defaultProps), { as: 'div' });
var UspBarLink = styled(UspBarText)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  text-decoration: underline;\n\n  &:hover {\n    color: ", ";\n  }\n"], ["\n  text-decoration: underline;\n\n  &:hover {\n    color: ", ";\n  }\n"])), themeGet('colors.brand.normal'));
UspBarLink.defaultProps = __assign(__assign({}, UspBarText.defaultProps), { as: 'a' });
var UspBarButton = styled.button(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: inline;\n  text-decoration: underline;\n  letter-spacing: normal;\n\n  font-size: 11px;\n\n  margin: 0;\n  padding: 0;\n  background: none;\n  border: none;\n  border-radius: 0;\n\n  color: inherit;\n\n  &[disabled] {\n    visibility: hidden;\n  }\n"], ["\n  display: inline;\n  text-decoration: underline;\n  letter-spacing: normal;\n\n  font-size: 11px;\n\n  margin: 0;\n  padding: 0;\n  background: none;\n  border: none;\n  border-radius: 0;\n\n  color: inherit;\n\n  &[disabled] {\n    visibility: hidden;\n  }\n"])));
var MobileInstalmentUspBar = /** @class */ (function (_super) {
    __extends(MobileInstalmentUspBar, _super);
    function MobileInstalmentUspBar(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { isOpen: false };
        return _this;
    }
    MobileInstalmentUspBar.prototype.show = function () {
        this.setState({ isOpen: true });
    };
    MobileInstalmentUspBar.prototype.hide = function () {
        this.setState({ isOpen: false });
    };
    MobileInstalmentUspBar.prototype.render = function () {
        var _this = this;
        var _a = this.props, instalmentPromoText = _a.instalmentPromoText, instalmentLegalText = _a.instalmentLegalText, moreInfoLabel = _a.moreInfoLabel, hideLabel = _a.hideLabel, legacyShopRebootMaxWidth = _a.legacyShopRebootMaxWidth;
        return (React.createElement(Grid, { legacyShopRebootMaxWidth: legacyShopRebootMaxWidth, bg: "gray.9" },
            React.createElement(UspBarContainer, { display: ['block', null, 'none'] },
                React.createElement(UspBarText, { textAlign: "center", color: "gray.3", textTransform: "none" },
                    instalmentPromoText,
                    ' ',
                    React.createElement(UspBarButton, __assign({}, getTrackerProps({
                        onClick: function () { return _this.show(); },
                        'data-testid': 'more-info-button',
                        disabled: this.state.isOpen,
                    }, {
                        event: 'headerTracking',
                        eventData: {
                            placement: 'uspBar',
                            labelIdentifier: 'h24_more_info',
                        },
                    })), moreInfoLabel))),
            React.createElement(UspBarContainer, { display: [this.state.isOpen ? 'block' : 'none', null, 'none'], flexDirection: "column" },
                React.createElement(UspBarContent, { "data-testid": "legal-text", textTransform: "none", color: "gray.3", dangerouslySetInnerHTML: {
                        __html: instalmentLegalText,
                    } }),
                React.createElement(UspBarContent, { color: "gray.3", textAlign: "right" },
                    React.createElement(UspBarButton, __assign({}, getTrackerProps({
                        onClick: function () { return _this.hide(); },
                        'data-testid': 'close-button',
                    }, {
                        event: 'headerTracking',
                        eventData: {
                            placement: 'uspBar',
                            labelIdentifier: 'h24_close',
                        },
                    })), hideLabel)))));
    };
    MobileInstalmentUspBar.propTypes = {
        instalmentPromoText: PropTypes.string.isRequired,
        moreInfoLabel: PropTypes.string.isRequired,
        instalmentLegalText: PropTypes.string.isRequired,
        hideLabel: PropTypes.string.isRequired,
        legacyShopRebootMaxWidth: PropTypes.bool,
    };
    return MobileInstalmentUspBar;
}(React.Component));
// disabled because of https://home24.atlassian.net/browse/FP-523
var SHOW_INSTALLMENT_USP_BAR = false;
var UspBar = function (_a) {
    var __legacy_shop_reboot_max_width = _a.__legacy_shop_reboot_max_width;
    return (React.createElement(LocaleConsumer, null, function (l10n) { return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width, bg: "gray.3" },
            React.createElement(UspBarContainer, { "data-testid": "usp-bar-container" },
                React.createElement(UspBarText, null, l10n.t('h24_days_return_policy')),
                React.createElement(UspBarText, null, l10n.t('h24_free_delivery_and_returns')),
                React.createElement(UspBarLink, __assign({}, getTrackerProps({
                    'data-testid': 'usp-bar-link',
                    href: l10n.prefix.t('h24_help_contact_url'),
                }, {
                    event: 'headerTracking',
                    eventData: {
                        placement: 'uspBar',
                        labelIdentifier: 'h24_help_contact',
                        listIndex: 2,
                        listLength: 3,
                    },
                })), l10n.t('h24_help_contact')))),
        SHOW_INSTALLMENT_USP_BAR &&
            l10n.region === 'DE' &&
            l10n.theme === 'h24' && (React.createElement(MobileInstalmentUspBar, { instalmentPromoText: l10n.t('h24_instalment_promo_text'), moreInfoLabel: l10n.t('h24_more_info'), instalmentLegalText: l10n.t('h24_instalment_promo_legal_text'), hideLabel: l10n.t('h24_close'), legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width })))); }));
};
UspBar.propTypes = {
    /** Should the max width be capped by current Reboot max width (default: true) */
    __legacy_shop_reboot_max_width: PropTypes.bool,
};
UspBar.defaultProps = {
    __legacy_shop_reboot_max_width: true,
};
export default UspBar;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
